import { FC } from "react";
import { HgProduct } from "../../../../types/taxonomy";
import { useGetProductRows } from "./hooks/useGetProductRows";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { DataGrid } from "@mui/x-data-grid";
import { useGetProductColumns } from "./hooks/useGetProductColumns";

interface Props {
  baseId: string;
  search: string;
  filteredProducts?: HgProduct[];
}

export const ProductsTable: FC<Props> = (props) => {
  const { productRows } = useGetProductRows(props.filteredProducts);
  const { productColumns } = useGetProductColumns();

  return (
    <Stack id="product-search-table-paper">
      <Typography variant="h5" data-testid="catalog-search-results-heading">
        {productRows.length} {productRows.length === 1 ? "Result" : "Results"}
      </Typography>
      <DataGrid
        data-testid="catalog-search-products-table"
        rows={productRows}
        columns={productColumns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        sortingOrder={["desc", "asc"]}
        pageSizeOptions={[10]}
        disableColumnMenu
        disableColumnResize
        disableRowSelectionOnClick
        hideFooterSelectedRowCount
        sx={{
          border: "none",
          "& .MuiDataGrid-iconSeparator": {
            display: "none",
          },
        }}
      />
    </Stack>
  );
};
